import xhrWorker from "workerize-loader!@/workers/xhr.worker";

import { isLoggedIn, logout, checkSession } from "@/common/authenticate";
import { getAccessToken } from "@/common/storage";
import { X_API_KEY } from "@/common/config";

export { _httpGet as httpGet };
export { _httpPost as httpPost };
export { _httpDelete as httpDelete };
export { _httpPatch as httpPatch };
export { _httpPut as httpPut };
export { _http as http };

const _httpGet = async (params) => {
  params.method = "GET";
  return _http(params);
};

const _httpPost = async (params) => {
  params.method = "POST";
  return _http(params);
};

const _httpDelete = async (params) => {
  params.method = "DELETE";
  return _http(params);
};

const _httpPatch = async (params) => {
  params.method = "PATCH";
  return _http(params);
};

const _httpPut = async (params) => {
  params.method = "PUT";
  return _http(params);
};

const _handleGiveFailedResponse = (result) => {
  let parsed = undefined;
  try {
    parsed = JSON.parse(result);
  } catch (err) {
    //Stop parsing error from getting out
  }
  if (parsed.status >= 400) {
    throw parsed;
  }
};

const _http = async (params) => {
  if (!params.skipCheckAuth) {
    await _checkAuth();
  }

  //TODO get rid of this when cloudfront is set up
  let bearerToken = getAccessToken();
  if (params.bearerToken) {
    bearerToken = params.bearerToken;
  }

  let message = {
    url: params.url,
    method: params.method,
    data: params.data,
    token: bearerToken,
    giveFailedResponse: params.giveFailedResponse,
  };

  if (params.noAuthorization) {
    message.noAuthorization = true;
  }

  if (params.noCache) {
    message.noCache = params.noCache;
  }

  if (typeof params.xApiKey === "string") {
    message.xApiKey = params.xApiKey;
  } else if (
    (params.url && params.url.indexOf("hyperionapi") > -1) ||
    params.xApiKey === true
  ) {
    message.xApiKey = X_API_KEY;
  }
  if (
    (params.url && params.url.indexOf("hyperionapi") > -1) ||
    params.xApiKey
  ) {
    message.xApiKey = X_API_KEY;
  }

  if (params.apiKey) {
    message.apiKey = params.apiKey;
  }

  const WORKER = xhrWorker();

  let result = await WORKER.getData(message);
  message = null;

  WORKER.terminate();

  if (result === "Too Many Active Sessions") {
    console.log("_http saw too many active sessions"); //LOGOUT DEBUGGING
    await logout({ unauthenticated: true });
    return;
  }

  if (result === 401) {
    let reauthenticated = await checkSession();
    if (reauthenticated && !params.restartedAlready) {
      return restart(params);
    } else {
      console.error("_http saw 401 & failed reauthentication" + params.url);
      await logout({ unauthenticated: true });
    }
  }

  if (params.giveFailedResponse) {
    _handleGiveFailedResponse(result);
  }

  return result;
};

async function restart(params) {
  params.restartedAlready = true;
  return _http(params);
}

const _checkAuth = async () => {
  if (!(await isLoggedIn())) {
    console.log("_checkAuth saw not logged in"); //LOGOUT DEBUGGING
    await logout();
  }
};
